import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useEffectOnce } from "@lib-shared/hooks";
import { AppContext } from "core/app-context";
import { Page } from "core/constants";
import { Installation } from "core/models/installation-response";
import InstallationDetails from "./installation-details";

type InstallationProps = {
    onBack: () => void
}

const InstallationComponent = observer((props: InstallationProps) => {
    const store = useContext(AppContext);
    const { onBack } = props;
    const navigate = useNavigate();
    const [installation, setInstallation] = useState<Installation | undefined>(undefined);

    const { reference } = useParams();

    useEffectOnce(() => {
        if (!store.installations.length) {
            navigate(Page.search);
            return;
        }

        const install = store.installations.find(x => x.customer_ref === reference);

        if (!install?.subscriberDetails) {
            navigate(Page.installations);
            return;
        }

        store.updatePage("installation");
        setInstallation(install);
    });

    return installation ? <InstallationDetails installation={installation} onBack={onBack} /> : null;
});

export default InstallationComponent;
